import { Route, Routes } from "react-router-dom";
import { useEffect, useState } from "react";
import Home from "./Page/User/Home/Home";
import SearchStore from "./Page/User/Home/SearchStore";
import Help from "./Page/User/Help/Help";
import SignUp from "./Page/User/Sign/SignUp";
import Live from "./Page/User/Live/Live";
import AdminLogin from "./Page/Manage/AdminLogin/AdminLogin";
import Dashborad from "./Page/Manage/Dashboard/Dashborad";
import AdminSign from "./Page/Manage/AdminSign/AdminSign";
import AdminSignUp from "./Page/Manage/AdminSign/AdminSignUp";
import Livelist from "./Page/Manage/LiveList/ManageLivelist";
import LiveMake from "./Page/Manage/LiveList/LiveMake";
import AdminRoute from "./Component/Route/AdminRoute";
import LiveDetail from "./Page/Manage/LiveList/LiveDetail";
import Orderlist from "./Page/Manage/OrderList/Orderlist";
import Userlist from "./Page/Manage/UserList/Userlist";
import Setting from "./Page/Manage/Setting/Setting";
import CoinManage from "./Page/Manage/CoinManage/CoinManage";
import Livelist_mobile from "./Page/Manage/LiveList/Livelist_mobile";
import Live_Manage from "./Page/Manage/LiveManage/Live_Manage";
import User_Bill from "./Page/User/Bill/User_Bill";
import Rule from "./Component/UI/Rule";
import TutoLive from "./Page/User/TutoLive/TutoLive";

function App() {
  const [isView, setIsView] = useState(true);
  var useragt = navigator.userAgent.toLowerCase();

  useEffect(() => {
    if (useragt.match(/kakaotalk/i)) {
      setIsView(false);
    }

    const meta = document.createElement("meta");
    meta.name = "google";
    meta.content = "notranslate";
    document.getElementsByTagName("head")[0].appendChild(meta);
  }, []);

  return !isView ? (
    <div>test</div>
  ) : (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/search" element={<SearchStore />} />
      <Route path="/help" element={<Help />} />
      <Route path="/rule/:type" element={<Rule />} />
      <Route path="/signup" element={<SignUp />} />
      <Route path="/live/:seq" element={<Live />} />
      <Route path="/bill/:uid" element={<User_Bill />} />
      <Route path="/tutorial" element={<TutoLive />} />

      {/* 관리자 페이지 */}
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin/adminsign" element={<AdminSign />} />
      <Route path="/admin/adminsignup" element={<AdminSignUp />} />
      <Route path="admin">
        <Route
          path="dashboard"
          element={<AdminRoute component={Dashborad} />}
        />
        <Route
          path="livelist"
          element={
            <AdminRoute component={Livelist} component_m={Livelist_mobile} />
          }
        />
        <Route
          path="livelist/Live_manage/:seq"
          element={
            <AdminRoute component={Live_Manage} component_m={Live_Manage} />
          }
        />
        <Route
          path="livelist/:seq"
          element={<AdminRoute component={LiveDetail} />}
        />
        <Route
          path="livelist/make"
          element={<AdminRoute component={LiveMake} />}
        />
        <Route
          path="orderlist/:page"
          element={<AdminRoute component={Orderlist} />}
        />
        <Route
          path="userlist/:page"
          element={<AdminRoute component={Userlist} />}
        />
        <Route
          path="coinmanage"
          element={<AdminRoute component={CoinManage} />}
        />
        <Route path="setting" element={<AdminRoute component={Setting} />} />
      </Route>
    </Routes>
  );
}

export default App;
